(function ($) {
    $('[data-portraits]').each(function () {
        $component = $(this);
        $buttons = $component.find('[data-year-button]');
        $rows = $component.find('[data-year]');
        $buttons.on('click', function () {
            $button = $(this);
            if (!$button.hasClass('active')) {
                $buttons.removeClass('active');
                $button.addClass('active');
                var year = $button.attr('data-year-button');
                if (year === '*') {
                    $rows.removeClass('hide');
                } else {
                    $rows.filter('[data-year="' + year + '"]').removeClass('hide');
                    $rows.not('[data-year="' + year + '"]').addClass('hide');
                }

            }
        });
    });
}(jQuery));
